import { render } from "./AddEquipageModal.vue?vue&type=template&id=d3827700&ts=true"
import script from "./AddEquipageModal.vue?vue&type=script&lang=ts"
export * from "./AddEquipageModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__